import { AutocompleteInput, useGetList } from 'react-admin';
import { useState, useMemo } from 'react';
import { useInfiniteAutocomplete } from '../../../hooks/useInfiniteAutocomplete';

export const ProgramAutocomplete = (props: any) => {

    const {
        choices,
        isLoading,
        setSearchText,
        handleScroll,
    } = useInfiniteAutocomplete('programs', {
        baseFilter: { deleted: false },
        searchField: 'name',
    });

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'programId'}
            fullWidth
            label="Program"
            choices={choices}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
            ListboxProps={{ onScroll: handleScroll }}
        />
    );
};
